export const isPaidMediaXDP = (pathname: string) => {
  return (
    pathname.match('enroll/(learn/|specializations/|professional-certificates/)?[^/]+?/paidmedia((\\?|/).*)?$') ||
    pathname.match('(learn/|specializations/|professional-certificates/)([^/]+)/paidmedia((\\?|/).*)?$')
  );
};
